export function getBlockedMessage(params: {
  isAdmin: boolean;
  awaitingRootReply: boolean | undefined;
  isFinalized: boolean;
  finalizedMessage: string;
  awaitingMessage: string;
}) {
  const {
    isAdmin,
    awaitingRootReply,
    isFinalized,
    finalizedMessage,
    awaitingMessage,
  } = params;

  if (isFinalized) {
    return finalizedMessage;
  }

  if (isAdmin && awaitingRootReply) {
    return awaitingMessage;
  }

  return null;
}
